import React, { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import { Box, Button, Typography } from "@mui/material"
import { useDispatch } from "react-redux"
import dayjs from "dayjs"
import {
  ContentContainer,
  ButtonsContainer,
  ButtonContainer,
  ButtonTitle,
  MainButton,
  WhiteContainer,
  CheckContainer,
  Icon,
  TitleContainer,
  ExpensesWhiteCard,
  ExpensesContainer,
  ExpensesProgress,
  InfoContainer,
  bankLinkingStyles,
  ChangeBank,
  SkeletonLoader,
  CapitalizeTypography,
} from "./styled"
import UIIcon from "../../components/UIIcon"
import {
  DATE_MONTH_FORMAT,
  DATE_MOSCOW_TIMEZONE,
  ROUTES_PATHS,
} from "../../utils/constants"
import {
  resetSteps,
  setCurrentFlow,
  setCurrentStep,
} from "../../store/slices/routingSlice/routingSlice"
import { PHKOString } from "../../components/PHKOString"
import BankItem from "../../components/BankItem"
import { resetSlice as resetM2MSlice } from "../../store/slices/m2mSlice"
import { resetSlice as resetSBPScile } from "../../store/slices/settingsSBP"
import { resetSlice as resetTransferSlice } from "../../store/slices/c2cSlice"
import { resetSlice as resetLinkingSlice } from "../../store/slices/linkingSlice"
import { useGetDefaultPaymentToolBank } from "../../api/hooks/useGetDefaultPaymentToolBank"
import { useGetUserInfo } from "../../api/hooks/useGetUserInfo"
import { formatAmount } from "../../utils/formatters"
import { BalanceIndicator } from "../../components/BalanceIndicator"
import BalanceIndicatorModal from "../../components/Modal/BalanceIndicatorModal"
import { useGetExpensesTurnover } from "../../api/hooks/useGetExpensesTurnover"
import { STEPS_NAME } from "../../store/slices/routingSlice/flowsSteps"

const HomeScreen = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()

  const { data: defaultPaymentToolBank } = useGetDefaultPaymentToolBank()
  const {
    data: userInfo,
    isError,
    isLoadingError,
    isLoading: isUserDataLoading,
    isInitialLoading,
    isRefetching,
  } = useGetUserInfo()
  const userBalance = userInfo?.balance?.availableAmount || "0"

  const [open, setOpen] = useState(false)
  const { data: expensesTurnoverData } = useGetExpensesTurnover()
  const expensesTurnover = expensesTurnoverData
    ? formatAmount(expensesTurnoverData.monthTurnover)
    : "-"
  const currentMonthName = dayjs()
    .tz(DATE_MOSCOW_TIMEZONE)
    .format(DATE_MONTH_FORMAT)

  useEffect(() => {
    if (!isInitialLoading && !isRefetching) {
      setOpen(isError || isLoadingError)
    }
  }, [isError, isLoadingError, isInitialLoading, isRefetching])

  const handleClose = () => {
    setOpen(false)
  }
  const formattedBalance = formatAmount(userBalance)

  const handleLinkingClick = () => {
    navigate(`/${ROUTES_PATHS.linking}`)
    dispatch(setCurrentFlow("accountLinking"))
    dispatch(setCurrentStep(STEPS_NAME.linking.linkingBankSelection))
  }

  useEffect(() => {
    dispatch(resetSteps())
    dispatch(resetM2MSlice())
    dispatch(resetSBPScile())
    dispatch(resetTransferSlice())
    dispatch(resetLinkingSlice())
  }, [])

  const linkingTitle = defaultPaymentToolBank
    ? "Основной счет"
    : "Оплачивайте покупки в одно касание"

  const handleRefillClick = () => {
    navigate(`/${ROUTES_PATHS.refill}`)
    dispatch(setCurrentFlow("refillM2M"))
    dispatch(setCurrentStep(STEPS_NAME.m2mPull.refill))
  }

  return (
    <ContentContainer>
      {isUserDataLoading ? (
        <SkeletonLoader
          animation="wave"
          variant="rounded"
          width="100%"
          height={72}
        />
      ) : (
        <BalanceIndicator
          formattedBalance={formattedBalance}
          baseSize={54}
          variant="h1"
        />
      )}
      <ButtonsContainer>
        <ButtonContainer onClick={handleRefillClick}>
          <MainButton>
            <UIIcon iconName="replenish" size={23} />
          </MainButton>
          <ButtonTitle>Пополнить</ButtonTitle>
        </ButtonContainer>
        <ButtonContainer onClick={() => navigate(`/${ROUTES_PATHS.withdraw}`)}>
          <MainButton>
            <UIIcon iconName="send" size={23} />
          </MainButton>
          <ButtonTitle>Перевести</ButtonTitle>
        </ButtonContainer>
        <ButtonContainer onClick={() => navigate(`/${ROUTES_PATHS.qr}`)}>
          <MainButton>
            <UIIcon iconName="qrCodeIcon" size={23} />
          </MainButton>
          <ButtonTitle>Оплатить</ButtonTitle>
        </ButtonContainer>
      </ButtonsContainer>
      <WhiteContainer>
        <Box sx={bankLinkingStyles}>
          <Typography variant="h4Bold">{linkingTitle}</Typography>
          {defaultPaymentToolBank && linkingTitle === "Основной счет" && (
            <Button sx={ChangeBank} onClick={handleLinkingClick} variant="text">
              Изменить
            </Button>
          )}
        </Box>
        <CheckContainer onClick={handleLinkingClick}>
          {!defaultPaymentToolBank ? (
            <InfoContainer>
              <Icon>
                <UIIcon iconName="sbpIcon" size={46} />
              </Icon>
              <TitleContainer>
                <Typography variant="h4">Привязать счет</Typography>
                <Typography variant="h6">Система быстрых платежей</Typography>
              </TitleContainer>
            </InfoContainer>
          ) : (
            <BankItem
              bank={defaultPaymentToolBank}
              description="Система быстрых платежей"
            />
          )}
          {!defaultPaymentToolBank && <UIIcon iconName="arrowForward" />}
        </CheckContainer>
      </WhiteContainer>
      <ExpensesWhiteCard
        onClick={() => navigate(`/${ROUTES_PATHS.operationsHistory}`)}
      >
        <ExpensesContainer>
          <Typography variant="h4Bold">Расходы</Typography>
          <Typography variant="h4Bold">{expensesTurnover} ₽</Typography>
        </ExpensesContainer>
        <CapitalizeTypography variant="h6">
          {String(currentMonthName)}
        </CapitalizeTypography>
        <ExpensesProgress variant="determinate" value={100} />
      </ExpensesWhiteCard>
      {/* <Button
        variant="contained"
        onClick={() => {
          navigate(
            "/me2me-agreement?token=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJjdXN0b21lcklkIjoiMzQ1ZWViMzYtZGVkZi00MGMzLTljZDgtYzU1ZWU5NmFkZGMxIiwicGFydG5lcklkIjoiOTE4ODdjOWItMDA3ZC00MzQxLTk1YzUtNzBiMjYzYjgzOWU5IiwicGhvbmVOdW1iZXIiOiI3MDEwMzMxMDA3NiIsImV4cCI6MTcxNDc0MTI2MywiaXNzIjoiaGVybWVzIiwiYXVkIjoiaGVybWVzLWJlZWxpbmUtcHJlcHJvY2Vzc2luZy1hcGktcmVzb3VyY2UifQ.nsyjgqD-JrdQQvynB3yO0BIxNl_RCXC-QNIy4Bbqzf8&IncomeRequestId=8e8ec017-f66c-4bd4-abf8-168aef297a7b&HasAgreement=True",
          )
        }}
      >
        M2M_Push FLOW TEST
      </Button> */}
      <PHKOString />
      <BalanceIndicatorModal onClose={handleClose} open={open} />
    </ContentContainer>
  )
}

export default HomeScreen
